import { Notificacion, NotificacionExtendida } from '@components/general/Alertas/Alertas';
import UserContext from '@context/User/UserContext';
import { createPaymentIntent, updatePaymentIntentPlan } from '@helpers/httpRequests/httpRequestsPagos/httpRequestsPagos';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js'
import React, { useContext, useEffect } from 'react'
import { useState } from 'react';
import { Button, Form, Image, Spinner } from 'react-bootstrap'
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const FormularioNuevaCompra = ({imgProducto = require("@assets/images/click.png"), precioProducto , precioProductoUSD, nombreProducto, compraExterna, compraLectura, folioContrato, codigoAplicado, precios, preciosXCodigo = undefined, valueRadioButton, idCodigoDescuento = undefined, successUrl = undefined, msiMax = 3, msiEnabled = false }) => {
    const { contextValue, setContextValue } = useContext(UserContext);

    const history = useHistory();

    const [loading, setLoading] = useState(false);

    const stripe = useStripe();
	const elements = useElements();
	const [cargando, setCargando] = useState(false);
	const [message, setMessage] = useState('');

	const [nombreCliente, setNombreCliente] = useState('');
	const [correoCliente, setCorreoCliente] = useState('');
	const [diferirCompraLectura, setDiferirCompraLectura] = useState(false);
	const [paymentIntentPlan, setPaymentIntentPlan] = useState(null);
	const [mesesDiferir, setMesesDiferir] = useState(0);

	const [showCheck, setShowCheck] = useState(false);
	const [cardComplete, setCardComplete] = useState(false);
	const [cardError, setCardError] = useState(null);
	
	const handleCardChange = (event) =>{
		if((event.complete || event.value?.length > 0) && msiEnabled) {
			// console.log("SE MUESTRA EL CHECK")
			setShowCheck(true);
		}else{ 
			// console.log("SE OCULTA EL CHECK")
			setShowCheck(false);
		}
	}

	const handleOnChange = ({currentTarget}) => {
		const {value, name} = currentTarget;

		if(name === 'nombreCliente'){
			setNombreCliente(value);
		}

		if(name === 'correoCliente'){
			setCorreoCliente(value);
		}
	}

	const createPaymentMethod = async() => {
		try {
			const { paymentMethod, error } = await stripe.createPaymentMethod({
				type: 'card',
				card: elements.getElement(CardElement),
				billing_details: {
				  name: nombreCliente,
				},
			  });
		
			//   console.log(paymentMethod)


			  return paymentMethod;


			  
		} catch (error) {
			console.log(error)
		}
	}

	const createPaymentIntentPlans = async() => {
		try {
			setCargando(true);
			const paymentMethod = await createPaymentMethod();
			const res = await createPaymentIntent({
				amount: compraExterna ? 16000: 299000,
				currency: compraExterna ? "usd": "mxn",
				paymentMethodId: paymentMethod.id,
			  })

			//   console.log(res);
			  setPaymentIntentPlan(res);

			  setCargando(false);

		} catch (error) {
			console.log(error)
			setCargando(false);
		}
	}

	const updatePaymentIntent = async({currentTarget}) => {
		try {
			setCargando(true);
			const {value} = currentTarget;

			setMesesDiferir(value==='contado' ? 0 : value);

			// console.log(value);

			const paymentMethod = await createPaymentMethod();
			const res = await updatePaymentIntentPlan({
				amount: compraExterna ? precioProductoUSD: precioProducto,
				currency: compraExterna ? "usd": "mxn",
				paymentMethodId: paymentMethod.id,
				count: value,
			  })

			//   console.log(res);
			  setPaymentIntentPlan(res);
			  setCargando(false);

		} catch (error) {
			  setCargando(false);
			  console.log(error)
		}
	}
  
	const handleSubmit = async (e) => {
	  e.preventDefault();
	  setLoading(true);

	  if (!stripe || !elements) {
		console.log("Stripe aún no está cargado");

		return;
	  }
	  const cardElement = elements.getElement(CardElement);

	//   console.log(cardElement)

	  if(nombreCliente === '' || correoCliente === ''){
		console.log("Campos vacios");
		setMessage('Agrega tu nombre y un correo electrónico');
		setLoading(false);
		return;
	  }
  
	 try {
  
	
		// if (error) {
		//   console.log(error);
		//   Notificacion("error", "Ocurrió un error con el pago, intente con otro método de pago")
		//   return;
		// }
		
		//Se crea el paymentIntent sin plan de meses sin intereses, aqui validar si está vacio el state de payment intent plan

		const paymentMethod = await createPaymentMethod();

		let res = {};

		if(!paymentIntentPlan){
			 res = await createPaymentIntent({
			  amount: compraExterna ? precioProductoUSD: precioProducto,
			  currency: compraExterna ? "usd": "mxn",
			  paymentMethodId: paymentMethod.id,
			})
	  
			// console.log(res)

		}


		const result = await stripe.confirmCardPayment(!paymentIntentPlan ? res.client_secret : paymentIntentPlan.client_secret, {
			payment_method: {
			  card: elements.getElement(CardElement),
			  billing_details: {
				name: nombreCliente,
				email: correoCliente,
			  },
			},
		  });
		  
		  if (result.error) {
			// console.log("❌ Error al confirmar pago:", result.error.message);
			NotificacionExtendida("error", result.error.message)

		  } else if (result.paymentIntent.status === "succeeded") {
			// console.log("✅ Pago exitoso");

			NotificacionExtendida("success", successUrl ? "Compra realizada con éxito" : "Compra realizada con éxito, por favor no cierres esta ventana")


			delete contextValue.preciosDescuento;

			setContextValue({
				...contextValue,
				compra: {
					...contextValue.compra,
					stripeSession: {
						metadata: {
							metodoPago: 'contado',
							folioContrato
						},
						payment_intent: result.paymentIntent.id,
						payment_method: result.paymentIntent.payment_method,

					},
					codigoAplicado: compraLectura ? true : codigoAplicado,
					idCodigoDescuento: compraLectura ? precios.lecturaVeloz.idCodigo : idCodigoDescuento,
					preciosSeleccionados: preciosXCodigo,
					metodoPago: compraLectura ? "contado" :valueRadioButton,
				},
			});	


			if(successUrl){
                setTimeout(() => {
                    history.replace(successUrl)
                }, 3000);
            }

		  } else if (result.paymentIntent.status === "requires_action") {
			// console.log("⚠️ Se necesita autenticación 3D Secure");
			// Stripe se encarga de mostrar el popup automáticamente.
		  }

		//   console.log(result)

		setNombreCliente("");
		setCorreoCliente("");
		cardElement.clear();
		setDiferirCompraLectura(false);
		setPaymentIntentPlan(null);
		setMesesDiferir(0);
	
		setLoading(false);
	 } catch (error) {
		console.log(error)
		setNombreCliente("");
		setCorreoCliente("");
		cardElement.clear();
		setDiferirCompraLectura(false);
		setPaymentIntentPlan(null);
		setMesesDiferir(0);
	
		setLoading(false);
		Notificacion("error", "Ocurrió un error con el pago, por favor intente de nuevo")

	 }
	};



    useEffect(() => {
        if(diferirCompraLectura){
        //Crear paymentIntent para recuperar los planes disponibles
        createPaymentIntentPlans();
        }

        if(!diferirCompraLectura && paymentIntentPlan !== null){
        setPaymentIntentPlan(null);
        setMesesDiferir(0)
        }

    }, [diferirCompraLectura])

    

    useEffect(() => {
        if(elements) {
            const cardElement = elements.getElement(CardElement);
            if (!cardElement) return;
    
            const handleChange = (event) => {
                setCardComplete(event.complete); // true si todos los campos están llenos
                setCardError(event.error ? event.error.message : null); // guarda el error si hay
            };
    
            cardElement.on('change', handleChange);
    
            return () => {
                cardElement.off('change', handleChange);
            };
        }
    }, [elements]);
  return (
    <Form className="form-lectura-stripe" onSubmit={handleSubmit}>
        <div className="text-center">
        <Image style={{margin: "auto"}} src={imgProducto} width={200} className="fluid" alt="Lectura logo" />
        <h3 className="text-dark mt-4">{nombreProducto}</h3>
        </div>
        <Form.Control onChange={handleOnChange} value={nombreCliente} name="nombreCliente" className="mb-4 mt-3" type="input" placeholder="Nombre completo" />
        <Form.Control onChange={handleOnChange} value={correoCliente} name="correoCliente" className="mb-4 mt-3" type="email" placeholder="Correo electrónico" />
        <CardElement onChange={handleCardChange} options={{
            style: {
            base: {
                fontSize: '16px',
                color: '#32325d',
                fontFamily: 'Arial, sans-serif',
                '::placeholder': {
                color: '#a0aec0',
                },
            },
            invalid: {
                color: '#e53e3e',
            },
            },
        }} />

        {showCheck && (
            <Form.Check 
                checked={diferirCompraLectura}
                className="mt-4 mb-3"
                style={{color: "#32325d"}}
                type={'checkbox'}
                id={`msi`}
                label={`Diferir pago a meses sin intereses`}
                onChange={() => setDiferirCompraLectura(!diferirCompraLectura)}
            />
        )}

        {(paymentIntentPlan !== null && diferirCompraLectura) && (
            (paymentIntentPlan.payment_method_options.card.installments.available_plans.length > 0) ? 
            (
                <Form.Select onChange={updatePaymentIntent} aria-label="Default select example">
                <option value="contado">Selecciona un plan</option>
                {paymentIntentPlan.payment_method_options.card.installments.available_plans.map((plan) => (
                    (plan.count <= msiMax) && (
                        <option value={plan.count}>{`${plan.count} meses sin intereses`}</option>
                    )
                ))}
                
                </Form.Select>
            ): (
                <span className="text-danger my-3">Tu metodo de pago no permite diferir tu compra a meses sin intereses</span>
            )
            
        )}

            <div className="text-dark mt-4">
                <p>Resumen de tu compra:</p>
                <p>Costo total: <b>${compraExterna ? precioProductoUSD / 100 : precioProducto /100}.00MXN</b></p>
                {(diferirCompraLectura && paymentIntentPlan !== null && paymentIntentPlan.payment_method_options.card.installments.available_plans.length > 0 && mesesDiferir > 0) && (
                    <p>Costo en cuotas: {mesesDiferir} pagos de <b>${( compraExterna ? (precioProductoUSD / 100) : (precioProducto / 100) / mesesDiferir).toFixed(2)}MXN</b> </p>
                )}
            </div>


        
            {cargando ? (
                <div className="text-center">
                    <Spinner variant="secondary" />
                </div>
            ): (
                <div className="mt-4 d-grid gap-2">
                    <Button className="btn btn-success" type="submit" disabled={!stripe || loading || !cardComplete}>
                        {loading ? <b>Procesando...</b> : <b>Pagar</b>}
                    </Button>
                </div>
            )}

        {cardError && <p className="text-danger mt-2">{cardError}</p>}
        {message !== '' && <p className="text-danger mt-2">{message}</p>}
    </Form>
  )
}

export default FormularioNuevaCompra